import React from 'react'
import styled from 'styled-components'

export const Placeholder = styled.div`
  width: 16px;
  height: 16px;
`

const colors = {
  grey: '#56565A',
  orange: '#CC6900',
  blue: '#2e8ab8',
}

export const OneDot = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-pipeline-dot"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(4.000000, 6.000000)"
        fill={colors[color]}
        fillRule="nonzero"
      >
        <path
          d="M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z"
          id="Path-Copy-2"
        />
      </g>
    </g>
  </svg>
)

export const OneCenteredDot = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-pipeline-dot"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(4.000000, 6.000000)"
        fill={colors[color]}
        fillRule="nonzero"
      >
        <circle cx="4" cy="2" r="2px" />
      </g>
    </g>
  </svg>
)

export const TwoDots = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-pipeline-2dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(6.000000, 2.000000)"
        fill={colors[color]}
        fillRule="nonzero"
      >
        <path
          d="M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z"
          id="Path"
        />
        <path
          d="M2,8 C0.9,8 0,8.9 0,10 C0,11.1 0.9,12 2,12 C3.1,12 4,11.1 4,10 C4,8.9 3.1,8 2,8 Z"
          id="Path-Copy-3"
        />
      </g>
    </g>
  </svg>
)

export const ThreeDots = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-pipeline-3dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(2.000000, 2.000000)"
        fill={colors[color]}
        fillRule="nonzero"
      >
        <path
          d="M6,0 C4.9,0 4,0.9 4,2 C4,3.1 4.9,4 6,4 C7.1,4 8,3.1 8,2 C8,0.9 7.1,0 6,0 Z"
          id="Path-Copy"
        />
        <path
          d="M2,8 C0.9,8 0,8.9 0,10 C0,11.1 0.9,12 2,12 C3.1,12 4,11.1 4,10 C4,8.9 3.1,8 2,8 Z"
          id="Path-Copy-3"
        />
        <path
          d="M10,8 C8.9,8 8,8.9 8,10 C8,11.1 8.9,12 10,12 C11.1,12 12,11.1 12,10 C12,8.9 11.1,8 10,8 Z"
          id="Path-Copy-2"
        />
      </g>
    </g>
  </svg>
)

export const FourDots = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-pipeline-4dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group"
        transform="translate(2.000000, 2.000000)"
        fill={colors[color]}
        fillRule="nonzero"
      >
        <path
          d="M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z"
          id="Path"
        />
        <path
          d="M10,0 C8.9,0 8,0.9 8,2 C8,3.1 8.9,4 10,4 C11.1,4 12,3.1 12,2 C12,0.9 11.1,0 10,0 Z"
          id="Path-Copy"
        />
        <path
          d="M2,8 C0.9,8 0,8.9 0,10 C0,11.1 0.9,12 2,12 C3.1,12 4,11.1 4,10 C4,8.9 3.1,8 2,8 Z"
          id="Path-Copy-3"
        />
        <path
          d="M10,8 C8.9,8 8,8.9 8,10 C8,11.1 8.9,12 10,12 C11.1,12 12,11.1 12,10 C12,8.9 11.1,8 10,8 Z"
          id="Path-Copy-2"
        />
      </g>
    </g>
  </svg>
)

export const OneOrangeDot = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-loan-view-dot"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-4"
        transform="translate(4.000000, 6.000000)"
        fill="#CC6900"
        fillRule="nonzero"
      >
        <circle
          id="Oval-Copy-7"
          cx="2"
          cy="2"
          r="2"
        />
      </g>
    </g>
  </svg>
)

export const TwoOrangeDots = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-loan-view-2dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-4"
        transform="translate(6.000000, 2.000000)"
        fill="#CC6900"
        fillRule="nonzero"
      >
        <circle
          id="Oval-Copy-7"
          cx="2"
          cy="2"
          r="2"
        />
        <circle
          id="Oval-Copy-8"
          cx="2"
          cy="10"
          r="2"
        />
      </g>
    </g>
  </svg>
)

export const ThreeOrangeDots = ({ color }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-loan-view-3dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-4"
        transform="translate(2.000000, 2.000000)"
        fill="#CC6900"
        fillRule="nonzero"
      >
        <circle
          id="Oval-Copy-7"
          cx="6"
          cy="2"
          r="2"
        />
        <circle
          id="Oval-Copy-9"
          cx="2"
          cy="10"
          r="2"
        />
        <circle
          id="Oval-Copy-8"
          cx="10"
          cy="10"
          r="2"
        />
      </g>
    </g>
  </svg>
)

export const FourOrangeDots = (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icon-loan-view-4dots"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-4"
        transform="translate(2.000000, 2.000000)"
        fill="#CC6900"
        fillRule="nonzero"
      >
        <circle
          id="Oval-Copy-6"
          cx="2"
          cy="2"
          r="2"
        />
        <circle
          id="Oval-Copy-7"
          cx="10"
          cy="2"
          r="2"
        />
        <circle
          id="Oval-Copy-9"
          cx="2"
          cy="10"
          r="2"
        />
        <circle
          id="Oval-Copy-8"
          cx="10"
          cy="10"
          r="2"
        />
      </g>
    </g>
  </svg>
)
